@if (!!objective) {
    <div class="display-tree-objective d-flex flex-column"
         [ngClass]="{
            root: !objective.parentObjectiveId,
            'external-objective': isExternalObjective,
            unfocussed: !isFocussed,
            compact: isCompactView,
        }"
         [attr.id]="objective.objectiveId">
        <div class="objective-body"
             [class.has-progress]="showProgress">
            <div class="d-flex flex-column align-middle">
                <div class="d-flex flex-row objective-tree-title">
                    @if (objective.assigneePersonId && isFocussed) {
                        <adapt-link-person [personId]="objective.assigneePersonId"
                                           [showImage]="true"
                                           [showText]="false"></adapt-link-person>
                    }
                    <adapt-link-objective class="me-auto"
                                          [objective]="objective"
                                          [showStatus]="false"
                                          [showStatusIcon]="false"></adapt-link-objective>
                    @if (isExternalObjective && !isFocussed) {
                        <adapt-link-objectives-page class="align-self-center px-2"
                                                    [team]="objective.team"
                                                    [view]="treeViewType"></adapt-link-objectives-page>
                    }
                    @if (!isCompactView) {
                        @if (hasEditPermissions) {
                            <adapt-select-objective-status class="status-offset"
                                                           [objective]="objective"></adapt-select-objective-status>
                        }
                        @if (!hasEditPermissions) {
                            <adapt-display-objective-status class="status-offset"
                                                            [objectiveStatus]="objective.status"></adapt-display-objective-status>
                        }
                    }
                    @if (hasEditPermissions) {
                        <adapt-objective-actions [objective]="objective"
                                                 [currentPageTeamId]="currentPageTeamId"></adapt-objective-actions>
                    }
                </div>
            </div>
            <div class="d-flex flex-column">
                <div class="d-flex flex-row flex-wrap align-items-center gap-2">
                    @if (isFocussed) {
                        <span><b>Due</b> {{ objective.dueDate | adaptDate }}</span>
                        <adapt-link-objectives-page [team]="objective.team"
                                                    [view]="treeViewType"
                                                    [linkDisabled]="!isExternalObjective"></adapt-link-objectives-page>
                    }
                    @if (isCompactView) {
                        @if (hasEditPermissions) {
                            <adapt-select-objective-status class="d-inline-flex"
                                                           [objective]="objective"></adapt-select-objective-status>
                        }
                        @if (!hasEditPermissions) {
                            <adapt-display-objective-status class="d-inline-flex"
                                                            [isCompactView]="isCompactView"
                                                            [objectiveStatus]="objective.status"></adapt-display-objective-status>
                        }
                    }
                    @if (objective.labelLocations?.length) {
                        <adapt-display-labels [labelLocations]="objective.labelLocations"></adapt-display-labels>
                    }
                </div>
                @if (isFocussed && !isCompactView) {
                    @if (linkedObjectives.length > 0 || linkedActions.length > 0 || linkedMeetings.length > 0) {
                        <div class="related">
                            @if (linkedObjectives.length > 0) {
                                <small>Linked objectives</small>
                                <adapt-display-linked-objectives [objective]="objective"
                                                                 [showGroupObjectiveTextSuffix]="false"
                                                                 [currentPageTeamId]="currentPageTeamId"></adapt-display-linked-objectives>
                            }
                            @if (linkedActions.length > 0) {
                                <small>Linked actions</small>
                                @for (item of linkedActions; track item) {
                                    <div>
                                        <adapt-item-link class="item-title"
                                                         [item]="item"
                                                         [showSummary]="true"
                                                         [showStatus]="true"
                                                         [showPersonImageLink]="true"></adapt-item-link>
                                    </div>
                                }
                            }
                            @if (linkedMeetings.length > 0) {
                                <small>Associated meetings</small>
                                @for (meeting of linkedMeetings; track meeting) {
                                    <div>
                                        <adapt-link-team-meeting [meeting]="meeting"></adapt-link-team-meeting>
                                    </div>
                                }
                            }
                        </div>
                    }
                }
            </div>
        </div>
        @if (showProgress) {
            <div class="objective-footer">
                <adapt-progress-bar [percentageProgress]="objective.currentProgress"
                                    [scaleHeight]="1.25"
                                    colour="var(--adapt-open-blue-500)"
                                    backgroundColour="#f5f5f5"></adapt-progress-bar>
            </div>
        }
    </div>
}
